import { notify } from "./notify";
export default function validatesNotNull(data, displayMsg = true) {
  let errorsValidation = {};
  let error = false;

  data.forEach((element) => {
    if (!element.value) {
      errorsValidation[element.key] = "Campo obrigatório";
      error = true;
    } else {
      errorsValidation[element.key] = "";
    }
  });

  if (error && displayMsg) notify("Preencha os campos obrigatórios.");
  return { error, errorsValidation };
}
